/** Corner-handle bracket: one L-shaped path in a 24px box, drawn top-left; CSS mirrors it for the other corners. */
export const CROP_CORNER_BRACKET_VIEW_BOX = '0 0 24 24';
export const CROP_CORNER_BRACKET_PATH = 'M5 21V5H21';
